function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 421.969 387.959",
    enableBackground: "new 0 0 595.28 595.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -89, -105)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 176.304,
    cy: 147.57,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 206.116,
    cy: 170.179,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 148.213,
    cy: 170.179,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 157.918,
    cy: 204.735,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 195.714,
    cy: 204.735,
    r: 9.706,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 323.533,
    cy: 209.524,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 293.721,
    cy: 186.915,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 351.625,
    cy: 186.915,
    r: 9.706,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 341.919,
    cy: 152.359,
    r: 9.706,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 304.123,
    cy: 152.359,
    r: 9.705,
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.784,485.559H126.422c-18.05,0-32.731-13.03-32.731-29.045V283.756 c0-16.015,14.682-29.046,32.731-29.046h261.362c18.05,0,32.731,13.031,32.731,29.046v172.758 C420.516,472.529,405.834,485.559,387.784,485.559z M126.422,273.869c-7.357,0-13.574,4.527-13.574,9.888v172.758 c0,5.359,6.217,9.888,13.574,9.888h261.362c7.357,0,13.573-4.528,13.573-9.888V283.756c0-5.36-6.216-9.888-13.573-9.888H126.422z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.304,250.045c-38.689,0-70.163-31.474-70.163-70.161s31.474-70.163,70.163-70.163 c38.69,0,70.163,31.476,70.163,70.163S214.994,250.045,176.304,250.045z M176.304,128.879c-28.124,0-51.005,22.881-51.005,51.005 s22.881,51.003,51.005,51.003s51.005-22.879,51.005-51.003S204.428,128.879,176.304,128.879z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.673,250.045c-38.69,0-70.163-31.474-70.163-70.161s31.473-70.163,70.163-70.163 c38.689,0,70.163,31.476,70.163,70.163S361.362,250.045,322.673,250.045z M322.673,128.879c-28.124,0-51.005,22.881-51.005,51.005 s22.881,51.003,51.005,51.003s51.005-22.879,51.005-51.003S350.797,128.879,322.673,128.879z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.012,434.629c-36.722,0-58.887-19.137-59.812-19.951c-2.067-1.819-3.251-4.438-3.251-7.191v-80.621 c0-34.214,55.939-39.573,62.314-40.074c2.704-0.189,5.295,0.706,7.255,2.519c1.959,1.812,3.072,4.361,3.072,7.032V425.05 C501.59,430.34,497.301,434.629,492.012,434.629z M448.106,402.669c5.426,3.62,17.418,10.302,34.326,12.255V307.311 c-14.972,2.773-34.326,9.214-34.326,19.555V402.669z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.304,191.985c-6.67,0-12.1-5.429-12.1-12.101s5.43-12.1,12.1-12.1s12.101,5.428,12.101,12.1 S182.974,191.985,176.304,191.985z M176.304,172.574c-4.031,0-7.311,3.279-7.311,7.311c0,4.032,3.279,7.311,7.311,7.311 c4.032,0,7.311-3.278,7.311-7.311C183.614,175.853,180.336,172.574,176.304,172.574z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M323.533,191.985c-6.67,0-12.1-5.429-12.1-12.101s5.43-12.1,12.1-12.1s12.1,5.428,12.1,12.1 S330.203,191.985,323.533,191.985z M323.533,172.574c-4.031,0-7.311,3.279-7.311,7.311c0,4.032,3.279,7.311,7.311,7.311 c4.032,0,7.311-3.278,7.311-7.311C330.844,175.853,327.565,172.574,323.533,172.574z",
    style: {
      fill: "rgba(255, 255, 255, 1)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.acc17c82564eec71ef005786aecf2bf7.svg";
export { ForwardRef as ReactComponent };